"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentGroupToggle = void 0;
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./DocumentGroup.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DocumentGroupToggle = props => {
  const [isVisible, setIsVisible] = React.useState(false);
  const handleClick = () => {
    setIsVisible(!isVisible);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: styles['toggler'],
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: styles['type']
  }, /*#__PURE__*/React.createElement(_icons.IconFileDocument16, null)), /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, null, props.title)), /*#__PURE__*/React.createElement("i", {
    "aria-hidden": "true",
    className: styles['icon']
  }, isVisible ? /*#__PURE__*/React.createElement(_icons.IconActionChevronUp16, null) : /*#__PURE__*/React.createElement(_icons.IconActionChevronDown16, null))), isVisible && /*#__PURE__*/React.createElement("div", null, props.documents));
};
exports.DocumentGroupToggle = DocumentGroupToggle;